export const ThietBiColumnsMeta = [
  { key: 'index', title: 'STT' },
  { key: 'Info', title: 'Tên thiết bị' },
  { key: 'Imei', title: 'IMEI' },
  { key: 'State', title: 'Trạng thái phát' },
  { key: 'DeviceError', title: 'Trạng thái thiết bị' },
  { key: 'Volumne', title: 'ÂM LƯỢNG' },
  { key: 'Speaker', title: 'Loa' },
  { key: 'GroupName', title: 'ĐỊA BÀN PHÁT' },
  { key: 'TempAir', title: 'NHIỆT ĐỘ' },
  { key: 'GsmInfo', title: 'KẾT NỐI MẠNG' },
  { key: 'ExpiredDay', title: 'Quá hạn' },
  { key: 'WarrantyTime', title: 'Ngày hết hạn' },
  { key: 'LastUpdate', title: 'CẬP NHẬT' },
  { key: 'ManufactureName', title: 'Nhà thầu' },
  { key: 'SupplierName ', title: 'Hãng sản xuất' },
  { key: 'Configuration', title: 'Cấu hình' },
  { key: 'Firmware', title: 'Phần mềm' },
  { key: 'HardWare', title: 'Phần cứng' },
  { key: 'Action', title: 'HÀNH ĐỘNG' },
]
